module.exports = __webpack_public_path__ + "img/Icon_Proveedor_Especialistas_Hover.7603eebc.svg";